import React from 'react';
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { Dispatch } from 'redux';

import { validateEmail } from 'mf-shared/utils/emailValidator';

import Captcha from './Captcha';
import InputField from './InputField';

import styles from './style.css';

const isPhoneNumberValid = (phoneNumber: string) => {
  return (
    phoneNumber.length >= 10 &&
    phoneNumber.length <= 15 &&
    (phoneNumber.substr(0, 3) === '+62' || phoneNumber.substr(0, 1) === '0')
  );
};

const validate = (values: FormField) => {
  const { email } = values;
  const errors: FormErrors<FormField> = {};

  if (!email) {
    errors.email = 'The email address or phone number is required';
  } else if (Number.isNaN(Number(email)) && !validateEmail(email)) {
    errors.email = 'Enter a valid email address';
  } else if (!Number.isNaN(Number(email)) && !isPhoneNumberValid(email)) {
    errors.email = 'Enter a valid phone number';
  }

  if (!values.captcha) {
    errors.captcha = 'The captcha is not valid';
  }

  return errors;
};

const mapForm = {
  form: 'forgotPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const formConnector = reduxForm<FormField, ForgotPasswordFormProps>(mapForm);

interface FormField {
  email: string;
  captcha: string;
}

interface ForgotPasswordFormProps {
  readonly dispatch: Dispatch;
}

interface ForgotPasswordFormState {}

type Props = ForgotPasswordFormProps &
  InjectedFormProps<FormField, ForgotPasswordFormProps>;

class ForgotPasswordForm extends React.Component<
  Props,
  ForgotPasswordFormState
> {
  render() {
    const { handleSubmit, valid } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          component={InputField}
          name="email"
          maxLength="256"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        <br />
        <div
          className={`row section-captcha ${styles['margin-bottom-20']} ${styles['align-left-normal']}`}
        >
          <div className="col-xs-12 col-sm-12">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'center' does not exist on type 'JSX.Intr... Remove this comment to see the full error message */}
            <center className={`${styles['margin-bottom-30']}`}>
              <Field component={Captcha} name="captcha" />
              {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'center' does not exist on type 'JSX.Intr... Remove this comment to see the full error message */}
            </center>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={!valid}
        >
          Find account
        </button>
      </form>
    );
  }
}

export default formConnector(ForgotPasswordForm);
